import * as React from "react";
import {Route, Routes} from "react-router-dom";
import SafetyProjectPage from "./pages/safety_and_security/safety_and_security_page";
import Navbar from "./components/navbar";
import IgemFooter from "./sections/footer_section";
import LaboratoryPage from "./pages/laboratory/laboratory_page";
import TeamPage from "./pages/team/team_page";
import SocialImpactPage from "./pages/social_impact/social_impact_page";
import NotebookPage from "./pages/notebook/notebook_page";
import HomePage from "./pages/home/home_page";
import AttributionsPage from "./pages/attributions/attributions_page";
import HumanPracticesPage from "./pages/social_impact/human_practices_page";
import CollaborationsPage from "./pages/collaborations/collaborations_page";
import NotFoundPage from "./components/not_found";
import ProjectDescriptionPage from "./pages/project_description/project_description_page";
import EducationPage from "./pages/social_impact/education_page";
import HardwarePage from "./pages/engineering/hardware_biosensor";
import ContributionsPage from "./pages/team/contributions_page";
import Communication from "./pages/communication/communication";
import ProofOfConceptPage from "./pages/proof/proof_of_concept_page";
import SoftwarePage from "./pages/engineering/software_biosensor";
import ModelPage from "./pages/engineering/model_degradacion";
import DesignPage from "./pages/engineering/design";
import ImplementationPage from "./pages/engineering/implementation";
import ResultsPage from "./pages/engineering/results";
import PartnershipPage from "./pages/team/partnership";
import MeasurementPage from "./pages/engineering/measurement";
import PartsPage from "./pages/engineering/parts";
import SustainablePage from "./pages/social_impact/sustainable";
import AwardsPage from "./pages/awards/awards_page";
import BiosensorDegradationDesign from "./pages/engineering/biosensor_degradation_design";
import ArtCompanyPage from "./pages/team/art_company_page";
import Results from "./pages/project_description/results/results";
import Implementation from "./pages/project_description/implementation/implementation";


export default function App() {
    return (
        <div className="App">
            <Navbar/>
            <Routes basename={process.env.PUBLIC_UR}>
                <Route path="/teccem" element={<HomePage/>}/>
                <Route path="/teccem/attributions" element={<AttributionsPage/>}/>
                <Route path="/teccem/contribution" element={<ContributionsPage/>}/>
                <Route path="/teccem/description" element={<ProjectDescriptionPage/>}/>
                <Route path="/teccem/engineering" element={<BiosensorDegradationDesign/>}/>
                <Route path="/teccem/collaborations" element={<CollaborationsPage/>}/>
                <Route path="/teccem/partnership" element={<PartnershipPage/>}/>
                <Route path="/teccem/human-practices" element={<HumanPracticesPage/>}/>
                <Route path="/teccem/model" element={<ModelPage/>}/>
                <Route path="/teccem/proof-of-concept" element={<ProofOfConceptPage/>}/>
                <Route path="/teccem/communication" element={<Communication/>}/>
                <Route path="/teccem/hardware" element={<HardwarePage/>}/>
                <Route path="/teccem/software" element={<SoftwarePage/>}/>
                <Route path="/teccem/parts" element={<PartsPage/>}/>
                <Route path="/teccem/safety" element={<SafetyProjectPage/>}/>
                <Route path="/teccem/sustainable" element={<SustainablePage/>}/>
                <Route path="/teccem/measurement" element={<MeasurementPage/>}/>
                <Route path="/teccem/education" element={<EducationPage/>}/>
                <Route path="/teccem/design" element={<DesignPage/>}/>
                <Route path="/teccem/laboratory" element={<LaboratoryPage/>}/>
                <Route path="/teccem/team" element={<TeamPage/>}/>
                <Route path="/teccem/social-impact" element={<SocialImpactPage/>}/>
                <Route path="/teccem/laboratory/notebook" element={<NotebookPage/>}/>
                <Route path="/teccem/awards" element={<AwardsPage/>}/>
                <Route path="/demo/design" element={<BiosensorDegradationDesign/>}/>
                <Route path="/teccem/artcompany" element={<ArtCompanyPage/>}/>
                <Route path={"/teccem/results"} element={<Results> </Results>}/>
                <Route path={"/teccem/implementation"} element={<Implementation/>}/>
                <Route path="*" element={<NotFoundPage/>}/>
            </Routes>
            <IgemFooter/>
        </div>
    );
}

